import { ApiHttpService } from '../../services'

export const ProductAttributeModule = {
    namespaced: true,
    state: {
        data: {
            columns: [
                { label: 'Name', field: 'name', sort: 'asc', clickable: true, width: '260px' },
                { label: 'Display Type', field: 'data_type', sort: 'asc', width: '140px', formatter: value => ({ BOOLEAN: 'Yes/No', LIST: 'List' }[value] || value) },
                // { label: 'Unit', field: 'unit_type', sort: 'asc', width: '140px' },
                {
                    label: 'Status',
                    field: 'active',
                    sort: 'asc',
                    badge: true,
                    filters: [{ text: 'Active', value: '1' }, { text: 'Inactive', value: '0' }],
                    badgeFormatter: value => [true, 1, '1', 'true'].includes(value)
                        ? { label: 'Active', color: 'success' }
                        : { label: 'Inactive', color: 'secondary' },
                },
                { label: 'Options', field: 'options_count', sort: 'asc', width: '100px' },
            ],
            rows: [],
        },
        length: 25,
        page: 1,
        total: 1,
        searchTerm: null,
        filters: {},
        loading: false,
        form: {},
        formStatus: 'create',
    },
    mutations: {
        setRows(state, rows) { state.data.rows = rows },
        setPage(state, page) { state.page = page },
        setTotal(state, total) { state.total = total },
        setLoading(state, value) { state.loading = value },
        setFormStatusCreate(state) { state.formStatus = 'create' },
        setFormStatusUpdate(state) { state.formStatus = 'update' },
        setFormRecord(state, record) { state.form = record },
    },
    actions: {
        async asyncGetData({ state, commit }, endpoint) {
            commit('setLoading', true)
            try {
                const response = await ApiHttpService.getRequest(endpoint, {
                    length: state.length,
                    page: state.page,
                    term: state.searchTerm,
                    filters: state.filters,
                })
                commit('setRows', response.data.data)
                commit('setPage', response.data.current_page)
                commit('setTotal', response.data.total)
                return response.data.data
            } finally {
                commit('setLoading', false)
            }
        },
        async storeRecord({ commit }, payload) {
            const response = await ApiHttpService.postRequest('product-attributes', payload)
            commit('setFormRecord', response.data.data || {})
            return response.data
        },
        async bulkStore(_, rows) {
            const response = await ApiHttpService.postRequest('product-attributes/bulk', { rows })
            return response.data
        },
        async updateRecord(_, payload) {
            const response = await ApiHttpService.update('product-attributes', payload)
            return response.data
        },
        async deleteRecord(_, rows) {
            const response = await ApiHttpService.deleteRequest('product-attributes', {
                tokens: rows.map(row => row.hash || row.id),
            })
            return response.data
        },
    },
    getters: {
        columns: state => state.data.columns,
        page: state => state.page,
        total: state => state.total,
        formStatus: state => state.formStatus,
        formRecord: state => state.form,
    },
}
